<non-admin-lock-panel></non-admin-lock-panel>

<div *ngIf="isAdmin" class="card mt-1">
    <div class="card-header text-center d-flex align-items-center">
        <h3 class="flex-fill" paflabel="Comptes_utilisateurs_internes"></h3>
        <button class="btn btn-sm btn-primary mx-1" type="button" (click)="ajouter()"><i
                class="fas fa-user-plus mr-1"></i>Ajouter</button>
        <button class="btn btn-sm btn-success mx-1" type="button" (click)="excelExport.save()"
            [disabled]="lstIntUsers.length==0"><i class="far fa-file-excel mr-1"></i>Exporter</button>
    </div>
    <div class="card-body small">
        <kendo-grid 
            #grid
            [data]="gridDatas" 
            [pageSize]="state.take" 
            [skip]="state.skip" 
            [sort]="state.sort"
            [sortable]="true" 
            [pageable]="pagerSettings" 
            [height]="500"        
            [filterable]="'menu'"
            [filter]="state.filter" 
            (sortChange)="sortChange($event)"
            (pageChange)="pageChange($event)"
            (dataStateChange)="dataStateChange($event)" 
            (dblclick)="dblClickGridEvent()" 
            (cellClick)="selectRow($event)"
            [selectable]="selectableSettings"
            [resizable]="true">
            <kendo-grid-column field="StatutLib" [sortable]="true" title="Statut" class="text-center"  [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="d-flex align-items-center">
                        <button class="btn btn-xs btn-info" (click)="view(dataItem)"><i class="fas fa-eye"></i></button>
                        <button *ngIf="dataItem.StatutId==1" class="btn btn-xs btn-warning ml-1"  (click)="edit(dataItem)"><i class="fas fa-edit"></i></button>
                        <button *ngIf="dataItem.StatutId==1" class="btn btn-xs btn-danger ml-1"  (click)="lock(dataItem)"><i class="fas fa-user-lock"></i></button>
                        <button *ngIf="dataItem.StatutId==2" class="btn btn-xs btn-success ml-1" (click)="unlock(dataItem)"><i class="fas fa-user-check"></i></button>
                        <span *ngIf="sharedDataSvc.debug" class="ml-1">{{dataItem.Id}}</span>
                        <span class="ml-1 flex-grow-1 text-center">
                            <span class="badge px-2" [ngClass]="{'badge-success':dataItem.StatutId==1,'badge-danger':dataItem.StatutId==2}">
                                {{dataItem.StatutLib}}
                            </span>
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ProfilLib" [sortable]="true" title="Profil"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="CivLib" title="Civilité"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="Lastname" title="Nom"  [sortable]="true"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="Firstname" title="Prénom"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="UtiGid" title="GID" [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="EmailDiff" title="Email"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="Phone" title="Téléphone"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="CellPhone" title="Mobile"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="referent.UtiGid" title="REF GID"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="referent.CivLib" title="Civilité REFERENT"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="referent.Lastname" title="Nom REFERENT"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="referent.Firstname" title="Prénom REFERENT"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="socsSAP" title="Soc SAP"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="etbsSAP" title="Etablissements"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="segments" title="Code Famille"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="Observations" title="Commentaire"  [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="DatCreation" title="Date de création" [format]="{ datetime: 'short' }" [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="datMaj" title="Date de modification" [format]="{ datetime: 'short' }" [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="datSusp" title="Date de suspension" [format]="{ datetime: 'short' }" [autoSize]="true"></kendo-grid-column>
            <kendo-grid-column field="motifSusp" title="Motif de blocage"  [autoSize]="true"></kendo-grid-column>
            
        </kendo-grid>
            <kendo-excelexport fileName="UtilisateursInternes.xlsx" [data]="lstIntUsers" #excelExport>
                <kendo-excelexport-column field="StatutLib" title="Statut"></kendo-excelexport-column>
                <kendo-excelexport-column field="ProfilLib" title="Profil"></kendo-excelexport-column>
                <kendo-excelexport-column field="CivLib" title="Civilité"></kendo-excelexport-column>
                <kendo-excelexport-column field="Lastname" title="Nom"></kendo-excelexport-column>
                <kendo-excelexport-column field="Firstname" title="Prénom"></kendo-excelexport-column>
                <kendo-excelexport-column field="UtiGid" title="GID"></kendo-excelexport-column>
                <kendo-excelexport-column field="EmailDiff" title="Email"></kendo-excelexport-column>
                <kendo-excelexport-column field="Phone" title="Téléphone"></kendo-excelexport-column>
                <kendo-excelexport-column field="CellPhone" title="Mobile"></kendo-excelexport-column>
                <kendo-excelexport-column field="referent.UtiGid" title="REF GID"></kendo-excelexport-column>
                <kendo-excelexport-column field="referent.CivLib" title="Civilité REFERENT"></kendo-excelexport-column>
                <kendo-excelexport-column field="referent.Lastname" title="Nom REFERENT"></kendo-excelexport-column>
                <kendo-excelexport-column field="referent.Firstname" title="Prénom REFERENT"></kendo-excelexport-column>
                <kendo-excelexport-column field="socsSAP" title="Soc SAP"></kendo-excelexport-column>
                <kendo-excelexport-column field="etbsSAP" title="Etablissements"></kendo-excelexport-column>
                <kendo-excelexport-column field="segments" title="Code famille"></kendo-excelexport-column>
                <kendo-excelexport-column field="Observations" title="Commentaire"></kendo-excelexport-column>
                <kendo-excelexport-column field="DatCreation" [width]="80" [cellOptions]="{format:'dd/mm/yyyy'}" title="Date de création"></kendo-excelexport-column>
                <kendo-excelexport-column field="datMaj" [width]="80" [cellOptions]="{format:'dd/mm/yyyy'}" title="Date de modification"></kendo-excelexport-column>
                <kendo-excelexport-column field="datSusp" [width]="80" [cellOptions]="{format:'dd/mm/yyyy'}" title="Date de suspension"></kendo-excelexport-column>
                <kendo-excelexport-column field="motifSusp" title="Motif de blocage"></kendo-excelexport-column>
                
            </kendo-excelexport>
    </div>
    <int-user-window 
        [showWindowSubject]="showWindowSubject" 
        [lstStatuts]="lstStatuts" 
        [lstFamilies]="lstSegments"
        [lstPerimeters]="lstPerimeters"
        [lstProfils]="lstProfils"
        [lstUserEtbsXRP]="lstUserEtbsXRP"
        [lstAllEtbsXRP]="lstAllEtbsXRP"
        [lstIntUsers]="lstIntUsers"
        [popupSettings]="popupSettings"
        (onWindowClosed)="onWindowClosed($event)"
        ></int-user-window>
</div>